import { RepositoryFactory } from '../../RepositoryFactory';
import Vue from 'vue';
const partners = new RepositoryFactory('partners');

export default {
  namespaced: true,
  state: {
    // Single user
    partner: {},
    partners: [],

    // Pagination Params
    currentPage: 1,
    total: 0,
    totalPages: 0,
    itemCount: 0,

    // Actions States
    loading: false,
    error: false,
    createError: '',
    deleteError: false,
    updateError: false,
  },
  getters: {
    getPartner(state) {
      return state.partner;
    },
    getPartners(state) {
      for (const iterator of state.partners) {
        const date = new Date(iterator.createdAt);
        iterator.createdAt = date.toLocaleDateString('pt-BR');
        if (iterator.to_donate) {
          iterator.to_donate = 'R$' + iterator.to_donate;
        } else {
          iterator.to_donate = 'R$' + 0.0;
        }
      }

      return state.partners.map(s => ({
        id: s.id,
        name: s.name,
        createdAt: s.createdAt,
        updatedAt: s.updatedAt,
        toDonate: s.to_donate,
      }));
    },
    getPartnersTableData(state) {
      return {
        error: state.error,
        loading: state.loading,
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        itemCount: state.itemCount,
        total: state.total,
      };
    },
    getError(state) {
      return state.error;
    },
    getCreateError(state) {
      if (state.createError) {
        return state.createError.message;
      } else {
        return '';
      }
    },
  },
  mutations: {
    SET_PARTNER(state, data) {
      state.partner = data;
    },
    SET_PARTNERS(state, data) {
      state.partners = data.items;
      state.total = data.totalOfItems;
      state.totalPages = data.pageCount;
    },
    SET_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_ALL_PARTNERS(state, data) {
      state.partners = data;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_CREATE_ERROR(state, error) {
      state.createError = error;
    },
  },
  actions: {
    setPage: async ({ commit, dispatch }, page) => {
      commit('SET_PAGE', page);
      dispatch('getPartners');
    },
    resetPagination: async ({ commit, dispatch }) => {
      commit('SET_PAGE', 1);
      dispatch('getPartners');
    },
    searchPartner: async ({ commit }, search) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await partners.getWithSearch(search);
        commit('SET_PARTNERS', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    resetCreateError: ({ commit }) => {
      commit('SET_CREATE_ERROR', null);
    },
    create: async ({ dispatch }, payload) => {
      try {
        const res = await partners.create(payload);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Parceiro criado com sucesso!',
        });
        dispatch('getPartners');
        return res.data.id;
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
    },
    updatePartner: async ({ dispatch }, payload) => {
      try {
        await partners.update(payload.id, payload.params);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Parceiro atualizado com sucesso!',
        });
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
      dispatch('getPartners');
    },
    getPartnerById: async ({ commit }, id) => {
      try {
        const { data } = await partners.getById(id);
        commit('SET_PARTNER', data);
      } catch (error) {}
    },
    getPartners: async ({ state, commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await partners.get(state.currentPage);
        commit('SET_PARTNERS', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    getPartnersNoPaginate: async ({ state, commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await partners.get();
        commit('SET_PARTNERS', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    getPartnersNoLimit: async ({ commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await partners.get();
        commit('SET_ALL_PARTNERS', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
  },
};
